
import initClient from './config'

const aliOss = {
    upload() {
        return new Promise(async (resolve, reject) => {
            if(err) {
                reject();
            }
            try {
                let options = {
                    // 获取分片上传进度、断点和返回值。
                    progress: (p, _checkpoint) => {
                        // const e = {};
                        // e.percent = parseInt(p * 100);
                        // console.log(p)
                      },
        
                    // 设置并发上传的分片数量。
                    // parallel: 10,
                    // 设置分片大小。默认值为1 MB，最小值为100 KB。
                    partSize: 1024 * 1024 * 1,
                    timeout: 120000
                }
                const {
                    res: resp
                } = await client.multipartUpload(filename, file, options)
                resolve(resp.requestUrls)
            } catch (e) {
                reject();
            }
    
        });
    },
    getFile(directory) {
        return  new Promise(async (resolve, reject) => {
            initClient().then(c => {
                // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
                const list = c.get(`product-service-center/${directory}`);
                resolve(list);
            })
    
        });
    },
    getList(directory) {
        return  new Promise(async (resolve, reject) => {
            initClient().then(c => {
                // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
                const list = c.list({prefix: `product-service-center/${directory}`});
                resolve(list);
            })
    
        });
        
    },
    preview(directory) {
        return  new Promise(async (resolve, reject) => {
            initClient().then(c => {
                // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
                const url = c.signatureUrl(`product-service-center/${directory}`, { protocol: 'https' });
                resolve(url);
            })
        });
        
    },
    putFile(directory, data, type) {
        return  new Promise(async (resolve, reject) => {
            initClient().then(c => {
                // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
                const result = c.put(`product-service-center/${directory}`, new Blob([JSON.stringify(data)], { type: type }));
                resolve(result);
            })
        });
    },
    delFile(directory) {
        return  new Promise(async (resolve, reject) => {
            initClient().then(c => {
                // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
                const result = c.delete(directory);
                resolve(result);
            })
        });
    }
}

export default aliOss;



// WEBPACK FOOTER //
// ./src/aliOss/index.js